import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/auth";
import { ImpSectorActiEconomica } from "./modalImpSectorActiEconomica";
import { ImpSectorActiEconomica2 } from "./modalImpSectorActiEconomica2";
import { ImprimirPatente } from "./modalImprimirPatente";
import { ConfiguracionModulo } from "./modalConfiguracionModulo";
import TablaComercio from "./tablaComercios";
import TablaComercio2 from "./tablaComerciosConsultarVerificacion";
import TablaClaseActividad from "./tablaClaseActividades";
import TablaVerificacion from "./tablaVerificaciones";
import { ActualizarRenovacion } from "./modalActualizarRenovacion";
import { ActualizarLicencia } from "./modalActualizarLicencia";
import TablaEstadoCuenta from "./tablaComerciosEstadoCuenta";
import TablaComercio4 from "./tablaComerciosAgenteRetencion";
import UsuarioWeb from "../../../pages/hacienda/UsuarioWeb";
import { TablaFechasVencimiento } from "./modalTablaFechasVencimiento";
import TablaComercioDeclaraUC from "./tablaComercioDeclaraUC";
import TablaUsuarioActividad from "./tablaUsuarioActividad";
import { Toasts } from "../../toasts";
import ModalImprimirDeudasComerciales from "./modalImprimirDeudasComerciales";
import ModalImprimirDeudasContribuyentes from "./ModalImprimirDeudasContribuyentes";
import Menu from "../../comun/Menu/Menu";
import Item from "../../comun/Menu/Item";
import DasboardActividad from "./graficasActividadEconomica";
import { ImpDejuradasAnual } from "./modalImpDeJuradas";
import TablaVerificarPagosEstadoCuenta from "./tablaVerificarEstadoCuenta";
import ImpListadoSolicitudLicencia from "./impModalSolicitudLicencia";
import { FrmImpCertMantenimiento } from "./FrmImpCertMantenimiento";
import AnalisisModuloAE from "./AnalisisModuloAE";
import ModalImprimirMontoDeclarados from "./modalImprimirMontoDeclarado";
import ModalImprimirComNoDeclarado from "./ModalImprimirComNoDecla";
import GraficaComerciosDeclive from "./GraficaComerciosDeclive";
import ModalImprimirComerciosDeclive from "./ModalImprimirComerciosDeclive";

function MenuPrincipaActiComer(props) {
  const { user } = useContext(AuthContext);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const accrepgensector = JSON.parse(localStorage.getItem("accrepgensector"));
  const [mostrar, setMostrar] = useState(false);
  const accreppatente = JSON.parse(localStorage.getItem("accreppatente"));
  const [idUsuario] = useState();
  const [titulo1, setTitulo1] = useState();
  const [titulo2, setTitulo2] = useState();
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );
  const [liquidador, setLiquidador] = useState(
    localStorage.getItem("liquidador"),
  );
  const [anio, setAnio] = useState();
  const [espiritu, setEspiritu] = useState(localStorage.getItem("espiritu"));
  const [permisos] = useState(localStorage.getItem("permisos"));
  const accedocuenta = JSON.parse(localStorage.getItem("accedocuenta"));
  const accrenovalicencia = JSON.parse(
    localStorage.getItem("accrenovalicencia"),
  );
  const acclicenciafunciona = JSON.parse(
    localStorage.getItem("acclicenciafunciona"),
  );
  let op = require("../../../../src/modulos/datos");
  let el;

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(obj.fechasistema);
    if (obj != null) {
      setLiquidador(obj.liquidador);
      setFechaSistema(obj.fechasistema);
      setEspiritu(obj.espiritu);
      var nanio = [];
      var aini = parseInt(obj.anioactu) - 7;
      var afin = parseInt(obj.anioactu);
      for (let i = 1; i <= afin - aini; i++) {
        nanio.push({ anio: aini + i });
      }
      setAnio(nanio);
    }
  }, []);

  window.onkeydown = function (event, index) {
    if (event.which === 119) {
      if ((el = document.getElementById("wrapper"))) {
        el.classList.toggle("toggled");
      }
    }
  };
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const [tabla, setTabla] = useState(0);
  const [show, setShow] = useState(false);

  const [
    solicitudRenovacionLicenciaPermission,
    setSolicitudRenovacionLicenciaPermission,
  ] = useState(false);
  const [solicitudLicenciaPermission, setSolicitudLicenciaPermission] =
    useState(false);
  const [estadoCuentaPermission, setEstadoCuentaPermission] = useState(false);
  const [listadoPorSectorPermission, setListadoPorSectorPermission] =
    useState(false);
  const [
    listadoActividadEconomicaPermission,
    setListadoActividadEconomicaPermission,
  ] = useState(false);

  useEffect(() => {
    if (accrenovalicencia && accrenovalicencia.toString() === "1")
      setSolicitudRenovacionLicenciaPermission(true);
    if (acclicenciafunciona && acclicenciafunciona.toString() === "1")
      setSolicitudLicenciaPermission(true);
    if (accedocuenta && accedocuenta.toString() === "1")
      setEstadoCuentaPermission(true);
    if (accrepgensector && accrepgensector.toString() === "1")
      setListadoPorSectorPermission(true);
    if (accreppatente && accreppatente.toString() === "1")
      setListadoActividadEconomicaPermission(true);

    if (tabla && tabla.toString() === "101") {
      setTitulo1("Impresión General de Contribuyentes");
      setTitulo2("Listado General de Contribuyentes");
    }
    if (tabla && tabla.toString() === "102") {
      setTitulo1(
        "Listado General de Impresión Licencias Actividades Económicas",
      );
      setTitulo2(
        "Listado General de Impresión Licencias Actividades Económicas",
      );
    }
    if (tabla && tabla.toString() === "103") {
      setTitulo1("Impresión General de Contribuyentes por Tipo de Actividad");
      setTitulo2("Listado Contribuyentes por Tipo de Actividad");
    }
    if (tabla && tabla.toString() === "104") {
      setTitulo1("Impresión General de Contribuyentes por Fecha");
      setTitulo2("Listado General de Contribuyentes por Fecha");
    }
    if (tabla && tabla.toString() === "108") {
      var reporte = "ListGenComercioCredito";
      window.open(
        op.reportes + "/actividadeconomica?" + "reporte=" + reporte,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setShow(0);
      setTabla(0);
    }
    if (tabla && tabla.toString() === "110") {
      var reporte = "Hac_DeudaGeneral";
      window.open(
        op.reportes + "/actividadeconomica?" + "reporte=" + reporte,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
      setShow(0);
      setTabla(0);
    }
    if (tabla && tabla.toString() === "115") {
      setMostrar(true);
    }
  }, [tabla]);

  const actualizcionItem = {
    title: "Actualizacion",
    icon: "fa fa-pen me-2",
    drop: [
      {
        title: "Registro de contribuyentes",
        icon: "fa fa-user-plus me-2",
        itemClickValue: 1,
      },
      {
        title: "Clasificador actividades economicas",
        icon: "fa fa-pen-square me-2",
        itemClickValue: 2,
      },
      {
        title: "Declaraciones Juradas",
        icon: "fas fa-address-card me-2",
        itemClickValue: 3,
      },
      {
        title: "Verificar pagos web",
        icon: "fas fa-address-card me-2",
        itemClickValue: 4,
      },
      {
        title: "Verificar pagos web x Estado de Cuenta",
        icon: "fas fa-address-card me-2",
        itemClickValue: 114,
      },
      {
        title: "Consultar verificaciones pagos web",
        icon: "fas fa-address-card me-2",
        itemClickValue: 5,
      },
      {
        permission: solicitudRenovacionLicenciaPermission,
        title: "Solicitud de renovacion de licencias A.E",
        icon: "fas fa-pen-square me-2",
        itemClickValue: 6,
      },
      {
        permission: solicitudLicenciaPermission,
        title: "Solicitud licencia de funcionamiento",
        icon: "fas fa-pen-square me-2",
        itemClickValue: 7,
      },
      {
        permission: estadoCuentaPermission,
        title: "Estados de cuenta",
        icon: "fas fa-address-card me-2",
        itemClickValue: 8,
      },
      {
        title: "Organismos (agentes de rentencion)",
        icon: "fas fa-address-card me-2",
        itemClickValue: 9,
      },
      {
        title: "Actualizacion de usuarios web",
        icon: "fas fa-address-card me-2",
        itemClickValue: 10,
      },
    ],
  };
  const imprimirItem = {
    title: "Imprimir",
    icon: "fa fa-print me-2",
    drop: [
      {
        permission: listadoPorSectorPermission,
        title: "Impresión General de Contribuyentes",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 101,
      },
      {
        permission: listadoActividadEconomicaPermission,
        title: "Listado emision de licencias de actividades economicas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 102,
      },
      {
        title: "Listado por actividades economicas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 103,
      },
      {
        title: "Listado por fecha de declaracion",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 104,
      },
      {
        title: "Listado por monto declarado",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 105,
      },
      {
        title: "Impresion de licencias de actividades economicas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 107,
      },
      {
        title: "Listado de contribuyentes por credito fiscal",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 108,
      },
      {
        title: "Resumen de declaracion anual",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 109,
      },
      {
        title: "Listado de solicitud de licencia",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 111,
      },
      {
        title: "Listado de solicitud de renovacion de licencia",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 112,
      },
      {
        title: "Listado de actividades economicas",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 113,
      },
      {
        title: "Certificado de Mantenimiento Licencia IAE",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 115,
      },
      {
        title: "Informe Mensual de Impuesto de Actividades Economicas",
        icon: "fas fa-print me-2",
        itemClickValue: 99,
        subDrop: null,
      },
      {
        permission: listadoPorSectorPermission,
        title: "Impresión de Listado Detallado de Contribuyente",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 98,
      },
      {
        title: "Impresión Lista de Contribuyentes no Declarados",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 97,
      },
      {
        title: "Impresión DE contribuyentes en declive",
        icon: "far fa-file-powerpoint me-2",
        itemClickValue: 118,
      },
    ],
  };
  const resumenGrafica = {
    title: "Analisis Grafico",
    icon: "fa fa-chart-pie me-2",

    drop: [
      {
        title: "RESUMEN Y ANALISIS GRAFICO",
        icon: "fas fa-screwdriver me-2",
        itemClickValue: 116,
      },
      {
        title: "GRAFICO DE COMERCIOS EN DECLIVE",
        icon: "fas fa-screwdriver me-2",
        itemClickValue: 117,
      },
    ],
  };
  const configuracionItem = {
    title: "Configuracion",
    icon: "fa fa-cog me-2",
    drop: [
      {
        title: "Configuracion del modulo",
        icon: "fas fa-screwdriver me-2",
        itemClickValue: 11,
      },
      {
        title: "Usuarios",
        icon: "fas fa-user me-2",
        itemClickValue: 12,
      },
      {
        title: "Actualizacion sector catastral",
        icon: "fas fa-user me-2",
        itemClickValue: 13,
      },
      {
        title: "Impresion visita",
        icon: "fas fa-user me-2",
        itemClickValue: 14,
      },
      {
        title: "Fecha vencimiento",
        icon: "fas fa-user me-2",
        itemClickValue: 15,
      },
    ],
  };

  const vista = {
    0: <DasboardActividad />,
    1: <TablaComercio setTabla={setTabla} />,
    2: <TablaClaseActividad setTabla={setTabla} />,
    3: <TablaComercioDeclaraUC setTabla={setTabla} />,
    4: <TablaVerificacion setTabla={setTabla} />,
    5: <TablaComercio2 setTabla={setTabla} />,
    6: (
      <ActualizarRenovacion
        setTabla={setTabla}
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        idusuario={idUsuario}
        liquidador={liquidador}
        fechasistema={fechaSistema}
        espiritu={espiritu}
        anios={anio}
      />
    ),
    7: (
      <ActualizarLicencia
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        idusuario={idUsuario}
        liquidador={liquidador}
        fechasistema={fechaSistema}
        espiritu={espiritu}
        anios={anio}
      />
    ),
    8: <TablaEstadoCuenta setTabla={setTabla} />,
    9: <TablaComercio4 setTabla={setTabla} />,
    10: <UsuarioWeb setTabla={setTabla} />,
    // CONFIGURACION ITEM
    11: (
      <ConfiguracionModulo
        show={show}
        setShow={setShow}
        setTabla={() => setTabla(0)}
        tipoconf={1}
        permisos={permisos}
      />
    ),
    12: <TablaUsuarioActividad setTabla={setTabla} />,
    // DONT HAVE ANY FUNCTIONALITY
    13: "",
    14: "",
    15: <TablaFechasVencimiento show={show} setShow={setShow} />,
    // IMPRIMIR ITEM
    101: (
      <ImpSectorActiEconomica
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporep={tabla}
      />
    ),
    102: (
      <ImpSectorActiEconomica
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporep={tabla}
      />
    ),
    103: (
      <ImpSectorActiEconomica
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporep={tabla}
      />
    ),
    104: (
      <ImpSectorActiEconomica2
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        titulo1={titulo1}
        titulo2={titulo2}
        tiporep={tabla}
      />
    ),
    // DONT HAVE ANY FUNCTIONALITY
    105: (
      <ModalImprimirMontoDeclarados show={show} setTabla={() => setTabla(0)} />
    ),
    106: "",
    107: (
      <ImprimirPatente
        show={show}
        onHideCancela={() => {
          setShow(false);
          setTabla(0);
        }}
        tiposolicitud={"2"}
        espiritu={espiritu}
        fechasistema={fechaSistema}
        idusuario={idUsuario}
      />
    ),
    // DONT HAVE ANY FUNCTIONALITY
    108: "",
    109: (
      <ImpDejuradasAnual
        show={show}
        setShow={setShow}
        setTabla={() => setTabla(0)}
      />
    ),
    110: "",
    111: (
      <ImpListadoSolicitudLicencia
        show={show}
        setShow={setShow}
        tabla={tabla}
        setTabla={() => setTabla(0)}
      />
    ),
    112: (
      <ImpListadoSolicitudLicencia
        show={show}
        setShow={setShow}
        tabla={tabla}
        setTabla={() => setTabla(0)}
      />
    ),
    113: (
      <ImpListadoSolicitudLicencia
        show={show}
        setShow={setShow}
        setTabla={() => setTabla(0)}
        tabla={113}
      />
    ),
    114: <TablaVerificarPagosEstadoCuenta />,
    116: <AnalisisModuloAE />,
    99: (
      <ModalImprimirDeudasComerciales show={show} setShow={() => setTabla(0)} />
    ),
    98: (
      <ModalImprimirDeudasContribuyentes
        show={show}
        setShow={() => setTabla(0)}
      />
    ),
    97: <ModalImprimirComNoDeclarado show={show} setShow={() => setTabla(0)} />,
    117: <GraficaComerciosDeclive />,
    118: (
      <ModalImprimirComerciosDeclive show={show} setShow={() => setTabla(0)} />
    ),
  };

  return (
    user && (
      <div>
        <Menu fechaSistema={fechaSistema} op={op} show={() => setTabla(0)}>
          <Item item={actualizcionItem} setTabla={setTabla} setShow={setShow} />
          <Item item={imprimirItem} setTabla={setTabla} setShow={setShow} />
          <Item item={resumenGrafica} setTabla={setTabla} setShow={setShow} />
          <Item
            item={configuracionItem}
            setTabla={setTabla}
            setShow={setShow}
          />
          <a
            href="/haciendaMunicipal"
            className="list-group-item list-group-item-action bg-transparent text-danger fw-bold"
          >
            <i className="fas fa-power-off me-2" />
            Salir
          </a>
        </Menu>
        <section
          className="col-xl-12 m-0 p-0 "
          style={{ height: "calc(100vh - 340px)" }}
        >
          {vista[tabla]}
        </section>
        <Toasts
          show={toast.mostrar}
          titulo={toast.titulo}
          mensaje={toast.mensaje}
          onHideCancela={cerrarToast}
        />
        <FrmImpCertMantenimiento
          show={mostrar}
          onHideCancela={() => {
            setMostrar(false);
            setTabla(0);
          }}
        />
      </div>
    )
  );
}
export default MenuPrincipaActiComer;
